import { render } from "./indexTaskCenter.vue?vue&type=template&id=611a48e9&scoped=true&ts=true"
import script from "./indexTaskCenter.vue?vue&type=script&lang=ts"
export * from "./indexTaskCenter.vue?vue&type=script&lang=ts"

import "./indexTaskCenter.vue?vue&type=style&index=0&id=611a48e9&lang=css"
import "./indexTaskCenter.vue?vue&type=style&index=1&id=611a48e9&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611a48e9"]])

export default __exports__